(function () {
  var patched = false;

  function textOf(node) {
    return (node && (node.innerText || node.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function labelIfEmpty(selector, label) {
    document.querySelectorAll(selector).forEach(function (node) {
      var name = node.getAttribute('aria-label') || node.getAttribute('aria-labelledby') || node.getAttribute('title') || textOf(node);
      if (!name) node.setAttribute('aria-label', label);
    });
  }

  function patchHeaderLogo() {
    document.querySelectorAll('a.header__heading-link, a[href="/"].header__heading-link').forEach(function (link) {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Plushwipes home');
      var img = link.querySelector('img');
      if (img && !img.getAttribute('alt')) img.setAttribute('alt', 'Plushwipes');
    });
  }

  function patchBlankPoweredByLinks() {
    document.querySelectorAll('a[href*="shopify.com"][href*="poweredby"]').forEach(function (link) {
      if (!textOf(link) && !link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'Powered by Shopify');
      }
    });
  }

  function patchLooxControls() {
    labelIfEmpty('a.loox-pn-close, button.loox-pn-close, [class*="loox"][class*="close"]', 'Close reviews popup');
    labelIfEmpty('a.loox-pn-branding', 'Loox reviews');
  }

  function patchDeferredMediaButtons() {
    document.querySelectorAll('button.deferred-media__poster').forEach(function (button) {
      if (!button.getAttribute('aria-label')) {
        var productTitle = textOf(document.querySelector('h1')) || 'product media';
        button.setAttribute('aria-label', 'Play ' + productTitle + ' video');
      }
    });
  }

  function patchHeadingNote() {
    document.querySelectorAll('h6').forEach(function (heading) {
      var copy = textOf(heading);
      if (/see testing details/i.test(copy)) {
        var p = document.createElement('p');
        p.className = heading.className;
        p.innerHTML = heading.innerHTML;
        p.setAttribute('data-accessibility-note', 'true');
        heading.replaceWith(p);
      }
    });
  }

  function patchIconButtons() {
    labelIfEmpty('button[name="minus"]', 'Decrease quantity');
    labelIfEmpty('button[name="plus"]', 'Increase quantity');
    labelIfEmpty('button.slider-button--prev', 'Previous slide');
    labelIfEmpty('button.slider-button--next', 'Next slide');
    labelIfEmpty('button.modal__close-button, button[aria-controls*="Modal"]', 'Close modal');
  }

  function runPatch() {
    patchHeaderLogo();
    patchBlankPoweredByLinks();
    patchLooxControls();
    patchDeferredMediaButtons();
    patchHeadingNote();
    patchIconButtons();
    patched = true;
  }

  function observeDynamicWidgets() {
    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(runPatch);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runPatch();
      observeDynamicWidgets();
    });
  } else {
    runPatch();
    observeDynamicWidgets();
  }

  window.PlushwipesAccessibilityPatch = {
    version: '2026-05-30-basic',
    rerun: runPatch,
    isPatched: function () { return patched; }
  };
})();
